import React from 'react'
import PropTypes from 'prop-types'
import {
    Typography,
    Button,
} from '@mui/material'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import useStyles from 'shared/hooks/useStyle'

import styles from './QrCodeRetry.style'

const propTypes = {
    qrCode: PropTypes.string,
    loggerNumber: PropTypes.string.isRequired,
    onRetry: PropTypes.func,
    validationMessageRender: PropTypes.element,
}

const QrCodeRetry = ({
    qrCode,
    loggerNumber,
    onRetry,
    validationMessageRender,
}) => {
    const { t } = useTranslation()
    const classes = useStyles(styles)

    return (
        <div>
            <Typography
                variant="h3"
                css={classes.text}
            >
                {`${t('QR_CODE')}:`}
                <span css={classes.code}>{qrCode}</span>
            </Typography>
            <Typography
                variant="h3"
                css={classes.text}
            >
                {`${t('LOGGER_NUMBER')}:`}
                <span css={classes.code}>{loggerNumber}</span>
            </Typography>
            {validationMessageRender !== undefined && validationMessageRender}
            { onRetry && (
                <div css={classes.actions}>
                    <Button
                        data-testid="retry-button"
                        css={classes.button}
                        onClick={onRetry}
                    >
                        {t('RETRY')}
                    </Button>
                </div>
            )}
        </div>
    )
}

QrCodeRetry.propTypes = propTypes

export default QrCodeRetry
